"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const caseStudies = [{
    id: 1,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/independent_film_project.png",
    title: "Independent Film Funding Success",
    outcome: "Secured $500K in production funding within 6 months through strategic packaging and investor relations."
  }, {
    id: 2,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/small_business_growth.png",
    title: "Small Business Operational Transformation",
    outcome: "Streamlined operations reduced overhead by 30% while increasing revenue by 45% year-over-year."
  }, {
    id: 3,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/documentary_distribution.png",
    title: "Documentary Distribution Deal",
    outcome: "Connected filmmakers with major streaming platform, achieving distribution across 190+ countries."
  }, {
    id: 4,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/startup_project_management.png",
    title: "Startup Project Management",
    outcome: "Implemented systematic workflows that accelerated product launch by 4 months ahead of schedule."
  }, {
    id: 5,
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/feature_film_packaging.png",
    title: "Feature Film Packaging",
    outcome: "Developed comprehensive project package that attracted A-list talent and studio interest."
  }];
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`mb-12 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">
            Success Stories
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Real results from clients who partnered with Freedom Productions to
            achieve their business and creative goals.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: false
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {Array.isArray(caseStudies) && caseStudies.map((study, i) => <CarouselItem key={study.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                  <div className="aspect-video w-full overflow-hidden rounded-t-xl">
                    <img src={study.image} alt={study.title} className="h-full w-full object-cover" />
                  </div>
                  <CardContent className="flex flex-col gap-4 pt-6">
                    <h3 className="font-display text-xl font-semibold text-foreground">
                      {study.title}
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed flex-grow">
                      {study.outcome}
                    </p>
                    <Link to="#" className="inline-flex items-center gap-2 text-primary font-medium text-sm underline underline-offset-4 transition-all duration-[var(--duration-fast)] hover:scale-[1.02] hover:translate-y-[-2px] hover:text-primary-hover">
                      Read More
                      <ArrowRight className="size-4" />
                    </Link>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex" />
          <CarouselNext className="hidden md:flex" />
        </Carousel>
      </div>
    </section>;
}